const Button = ({
  color = "blue",
  onClick = () => {},
  id = "",
  type = "button",
  disabled = false,
  children = <></>,
  className = "",
  hidden = false,
  dataTestId = "",
}) => {
  const backgroundColor = disabled ? "bg-gray-400" : `bg-${color}-600`;
  const hoverColor = disabled ? "hover:bg-gray-400" : `hover:bg-${color}-700`;

  if (hidden) {
    return <div className="h-12"></div>;
  }

  return (
    <button
      className={`px-8 py-3 m-2 ${backgroundColor} ${hoverColor} text-white font-semibold text-lg rounded-full shadow-md transition ${
        !disabled && "cursor-pointer"
      } ${className}`}
      onClick={() => onClick()}
      id={id}
      type={type}
      disabled={disabled}
      data-testid={dataTestId}
    >
      {children}
    </button>
  );
};

export default Button;
